<template>
  <div class="d-flex flex-column fill-viewport">
    <SiteHeader class="mb-0 bg-primary" />

    <div class="position-relative flex-fill d-flex slot-layout">
      <div class="container-fluid p-0">
        <slot />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import SiteHeader from '@/components/SiteHeader.vue';
</script>
<style lang="scss" scoped>
$mobile-header-height: 78px;
.slot-layout {
  margin-top: 2rem;
  @media screen and (max-width: 991px) {
    margin-top: 1rem;
  }
}
</style>
